/**
 * Calls provider post method that you pass in with values payload and
 * then attempts to make sense out of the error result messages if error.
 */
import { SubmissionError } from 'redux-form'
import _ from 'lodash'

const submit = async (postMethod, values) => {
  try {
    return await postMethod(null, values)
  } catch (err) {
    const errorResult = {}

    // fetch errors occur when there are network or permission issues
    // these errors will not be filled out with API custom error creation
    if (err && !err.statusText && !err.status) {
      errorResult._error = `[Error message: ${err.message}.]`
    } else if (typeof err !== 'undefined') {
      const firstError = _.get(err, 'body.errors[0]')
      if (firstError) {
        if (firstError.field) {
          errorResult._error = `${_.startCase(firstError.field)}: ${
            firstError.default_message
          }.`
        } else {
          errorResult._error = `${firstError.default_message}`
        }
      } else {
        const genericMessage = `${err.statusText} (${err.status}).`
        errorResult._error =
          _.get(err, 'body.message') || err.message || genericMessage
      }
    }
    throw new SubmissionError(errorResult)
  }
}

export default submit
